export default __webpack_public_path__ + "static/media/create-and-share.3fa4a048.jpg";